import api from "../../../../../utils/api";

export const getDashboardData = async () => {
    let {data} = await api.get('organizations/dashboard/handler')
    return data

    //return {}
}